import { useEffect, useState } from "react";
import { api } from "../lib/api";
import type { Invite } from "../lib/types";

function fmtDate(ms: number): string {
  return new Date(ms).toLocaleString();
}

export function Admin() {
  const [invites, setInvites] = useState<Invite[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState<string | null>(null);

  async function load() {
    try {
      setInvites(await api.listInvites());
    } catch (e) {
      setError((e as Error).message);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function create() {
    setBusy(true);
    try {
      await api.createInvite();
      await load();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  async function copy(text: string, token: string) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(token);
      setTimeout(() => setCopied(null), 1500);
    } catch {}
  }

  return (
    <div className="page page-pad-bottom">
      <h1>Invites</h1>
      <p className="muted">Generate a single-use link and send it to the family member you want to invite.</p>
      <button onClick={create} disabled={busy}>
        {busy ? "Creating…" : "+ Create invite link"}
      </button>
      {error && <div className="card" style={{ color: "var(--warn)" }}>{error}</div>}
      <h2>Recent invites</h2>
      {invites === null && <p className="muted">Loading…</p>}
      {invites && invites.length === 0 && <p className="muted">No invites yet.</p>}
      {invites && invites.map((inv) => (
        <div key={inv.token} className="card">
          <div className="flex-col" style={{ gap: "0.4rem" }}>
            <div className="muted">Created: {inv.createdAt ? fmtDate(inv.createdAt) : "—"}</div>
            <div className="muted">Expires: {fmtDate(inv.expiresAt)}</div>
            {inv.usedAt ? (
              <div className="finished">Used {fmtDate(inv.usedAt)}</div>
            ) : (
              <>
                <div className="big" style={{ wordBreak: "break-all" }}>{inv.url}</div>
                <button onClick={() => copy(inv.url, inv.token)}>
                  {copied === inv.token ? "✓ Copied" : "Copy link"}
                </button>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
